import U from "./index50.js";
const { toString: V } = Object.prototype, { getPrototypeOf: p } = Object, { iterator: g, toStringTag: E } = Symbol, _ = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), w = (e, t) => {
  let n = e;
  const r = [];
  for (; n != null && n !== Object.prototype; ) {
    if (r.indexOf(n) !== -1)
      return !1;
    if (r.push(n), _(n, t))
      return !0;
    n = p(n);
  }
  return !1;
}, k = (e, t) => e != null && w(e, t) ? e[t] : void 0, x = ((e) => (t) => {
  const n = V.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), c = (e) => (e = e.toLowerCase(), (t) => x(t) === e), F = (e) => (t) => typeof t === e, { isArray: a } = Array, d = F("undefined");
function y(e) {
  return e !== null && !d(e) && e.constructor !== null && !d(e.constructor) && f(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const L = c("ArrayBuffer");
function q(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && L(e.buffer), t;
}
const H = F("string"), f = F("function"), R = F("number"), m = (e) => e !== null && typeof e == "object", z = (e) => e === !0 || e === !1, h = (e) => {
  if (!m(e))
    return !1;
  const t = p(e);
  return (t === null || t === Object.prototype || p(t) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !w(e, E) && !w(e, g);
}, G = (e) => {
  if (!m(e) || y(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, J = c("Date"), K = c("File"), W = (e) => !!(e && typeof e.uri < "u"), $ = (e) => e && typeof e.getParts < "u", j = c("Blob"), Q = c("FileList"), X = (e) => m(e) && f(e.pipe);
function Y() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const B = Y(), C = typeof B.FormData < "u" ? B.FormData : void 0, Z = (e) => {
  if (!e)
    return !1;
  if (C && e instanceof C)
    return !0;
  const t = p(e);
  if (!t || t === Object.prototype || !f(e.append))
    return !1;
  const n = x(e);
  return n === "formdata" || // detect form-data instance
  n === "object" && f(e.toString) && e.toString() === "[object FormData]";
}, v = c("URLSearchParams"), [ee, te, ne, re] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(c), oe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function O(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), a(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    if (y(e))
      return;
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), l = s.length;
    let i;
    for (r = 0; r < l; r++)
      i = s[r], t.call(null, e[i], i, e);
  }
}
function T(e, t) {
  if (y(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const u = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), D = (e) => !d(e) && e !== u;
function A(...e) {
  const { caseless: t, skipUndefined: n } = D(this) && this || {}, r = {}, o = (s, l) => {
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    const i = t && typeof l == "string" && T(r, l) || l, b = _(r, i) ? r[i] : void 0;
    h(b) && h(s) ? r[i] = A(b, s) : h(s) ? r[i] = A({}, s) : a(s) ? r[i] = s.slice() : (!n || !d(s)) && (r[i] = s);
  };
  for (let s = 0, l = e.length; s < l; s++) {
    const i = e[s];
    if (!i || y(i) || (O(i, o), typeof i != "object" || a(i)))
      continue;
    const b = Object.getOwnPropertySymbols(i);
    for (let P = 0; P < b.length; P++) {
      const S = b[P];
      be.call(i, S) && o(i[S], S);
    }
  }
  return r;
}
const se = (e, t, n, { allOwnKeys: r } = {}) => (O(
  t,
  (o, s) => {
    n && f(o) ? Object.defineProperty(e, s, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: U(o, n),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, s, {
      __proto__: null,
      value: o,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: r }
), e), ie = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), le = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, fe = (e, t, n, r) => {
  let o, s, l;
  const i = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      l = o[s], (!r || r(l, e, t)) && !i[l] && (t[l] = e[l], i[l] = !0);
    e = n !== !1 && p(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, ce = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, ue = (e) => {
  if (!e)
    return null;
  if (a(e))
    return e;
  let t = e.length;
  if (!R(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, ae = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && p(Uint8Array)), pe = (e, t) => {
  const r = (e && e[g]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const s = o.value;
    t.call(e, s[0], s[1]);
  }
}, de = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, ye = c("HTMLFormElement"), me = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, r, o) {
  return r.toUpperCase() + o;
}), { propertyIsEnumerable: be } = Object.prototype, we = c("RegExp"), I = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  O(n, (o, s) => {
    let l;
    (l = t(o, s, e)) !== !1 && (r[s] = l || o);
  }), Object.defineProperties(e, r);
}, ge = (e) => {
  I(e, (t, n) => {
    if (f(e) && ["arguments", "caller", "callee"].includes(n))
      return !1;
    const r = e[n];
    if (f(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Oe = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((s) => {
      n[s] = !0;
    });
  };
  return a(e) ? r(e) : r(String(e).split(t)), n;
}, he = () => {
}, _e = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Fe(e) {
  return !!(e && f(e.append) && e[E] === "FormData" && e[g]);
}
const Pe = (e) => {
  const t = /* @__PURE__ */ new WeakSet(), n = (r) => {
    if (m(r)) {
      if (t.has(r))
        return;
      if (y(r))
        return r;
      if (!("toJSON" in r)) {
        t.add(r);
        const o = a(r) ? [] : {};
        return O(r, (s, l) => {
          const i = n(s);
          !d(i) && (o[l] = i);
        }), t.delete(r), o;
      }
    }
    return r;
  };
  return n(e);
}, Se = c("AsyncFunction"), Ae = (e) => e && (m(e) || f(e)) && f(e.then) && f(e.catch), M = ((e, t) => e ? setImmediate : t ? ((n, r) => (u.addEventListener(
  "message",
  ({ source: o, data: s }) => {
    o === u && s === n && r.length && r.shift()();
  },
  !1
), (o) => {
  r.push(o), u.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(typeof setImmediate == "function", f(u.postMessage)), xe = typeof queueMicrotask < "u" ? queueMicrotask.bind(u) : typeof process < "u" && process.nextTick || M, N = (e) => e != null && f(e[g]), Be = (e) => e != null && w(e, g) && N(e), Ee = {
  isArray: a,
  isArrayBuffer: L,
  isBuffer: y,
  isFormData: Z,
  isArrayBufferView: q,
  isString: H,
  isNumber: R,
  isBoolean: z,
  isObject: m,
  isPlainObject: h,
  isEmptyObject: G,
  isReadableStream: ee,
  isRequest: te,
  isResponse: ne,
  isHeaders: re,
  isUndefined: d,
  isDate: J,
  isFile: K,
  isReactNativeBlob: W,
  isReactNative: $,
  isBlob: j,
  isRegExp: we,
  isFunction: f,
  isStream: X,
  isURLSearchParams: v,
  isTypedArray: ae,
  isFileList: Q,
  forEach: O,
  merge: A,
  extend: se,
  trim: oe,
  stripBOM: ie,
  inherits: le,
  toFlatObject: fe,
  kindOf: x,
  kindOfTest: c,
  endsWith: ce,
  toArray: ue,
  forEachEntry: pe,
  matchAll: de,
  isHTMLForm: ye,
  hasOwnProperty: _,
  hasOwnProp: _,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: w,
  getSafeProp: k,
  reduceDescriptors: I,
  freezeMethods: ge,
  toObjectSet: Oe,
  toCamelCase: me,
  noop: he,
  toFiniteNumber: _e,
  findKey: T,
  global: u,
  isContextDefined: D,
  isSpecCompliantForm: Fe,
  toJSONObject: Pe,
  isAsyncFn: Se,
  isThenable: Ae,
  setImmediate: M,
  asap: xe,
  isIterable: N,
  isSafeIterable: Be
};
export {
  Ee as default
};
